module.exports = __webpack_public_path__ + "static/media/bstn-1.92026179.jpg";